<template>
<div class="flex flex-1 flex-col items-center">
    <VueFileAgent
      class="w-full"
      ref="vueFileAgent"
      :theme="theme"
      :multiple="false"
      :deletable="true"
      :meta="true"
      :accept="imagevalidation"
      :maxSize="'50KB'"
      :maxFiles="14"
      :helpText="imageHint"
      :errorText="{
        type: 'Invalid file type. Only JPG/JPEG/PNG Allowed',
        size: 'Files should not exceed 50kb in size',
      }"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      v-model="fileRecords"
     @upload:error="uploadEvent('upload:error', $event)"

    ></VueFileAgent>

    <vs-tooltip class="inline-block align-bottom" color="primary"
      text="Select files From Gdrive"
    >
      <vs-button
        class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
        color="primary"
        type="border"
        @click="driveIconClicked()"
        >
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
      </vs-button>
    </vs-tooltip>

    <div v-if="fileRecordsForUpload.length">
    <vs-divider/>
    <vs-button :disabled="!fileRecordsForUpload.length" @click="uploadFiles()">
      Upload {{ fileRecordsForUpload.length }} {{fileRecordsForUpload.length>1?'files':'file'}}
    </vs-button>
    </div>
</div>
</template>

<script>
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { getUploadedFilesId } from '@/api/assignment-question'

export default {
  name: 'FileTesting',
  mixins:[GoogleAuthorization],
  props: {

    file_repository_id:{
      required:false,
      type:Number,
      default:0
    }
  },
  data () {
    return {
      isCollapseCard:true,
      theme:'grid',
      imageHint:'Choose files or drag & drop here',
      imagevalidation:'',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [] // maintain an upload queue,
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    const customer_id = this.$store.getters.customerId

    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    this.imagevalidation = '.jpg, .jpeg, .png'
    this.imageHint = 'Choose/drag & drop image here'
    // gDrive
    this.fileSizeValidation = 50000 
    this.fileTypeValidation = 'photo'

  },
  methods: {
    uploadEvent (eventName, data) {
      
    },
    uploadFiles () {
      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {


          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type:'material',
        text:'Please wait we are uploading file'
      })


      data.then((response, error) => {
        const cdn = response[0].data.data.cdn
        if (response) {

          for (let i = 0;  i < response.length; i++) {

            const file_name = response[i].data.data.files[0].file_name
            const file_path = response[i].data.data.files[0].file_path


            const raw = JSON.stringify({
              file_repository_id: this.file_repository_id,
              files: [
                {
                  file_name,
                  file_path: `${cdn}${file_path}`
                }
              ]
            })

            const file_id_payload = raw
            this.getUploadFiles(file_id_payload)

          }
          this.$vs.loading.close()
        } else {
          this.$vs.loading.close()
        }
      })
        .catch(error => {
          this.$vs.loading.close()


        })
        .finally(this.$vs.loading.close())

      this.fileRecordsForUpload = []

    },
    async getUploadFiles (file_id_payload, type = 'system') {


      try {
        const res = await getUploadedFilesId(file_id_payload)
        console.log(res)

        if (res.data.message === 'files.createFile') {
          const fileObject = {
            files_id:res.data.data.files[0].files_id,
            files_repository_id:this.file_repository_id,
            file_image_url:res.data.data.files[0].file_path

          }

          // this.$emit('getImage', fileObject)

          // this.filesInfo.push(file)

          // console.log()
          const filesDriveInfo = res.data.data.files
          console.log(filesDriveInfo)
          let filesDrive = []
        
    
          if (type === 'drive') {
            
            filesDrive = filesDriveInfo.map(ele => {
              return {
                name: ele.file_name,
                sizeText: this.bytesToSize(ele.size),
                size: ele.size,
                type: ele.file_type,
                url: ele.file_path,
                color: 'green',
                upload: {
                  data: true,
                  error: false
                }
              }
            })
            console.log(filesDriveInfo)
            this.fileRecords.push(...filesDrive)
            console.log(filesDrive)
            const repo_id = this.files_repository_id
            console.log(repo_id)
            filesDriveInfo.forEach(ele => {
              console.log(repo_id)
              console.log(ele)
 
              this.$emit('getImage', {
                files_id:ele.files_id,
                files_repository_id:this.file_repository_id,
                file_image_url:ele.file_path
              })

            })
            this.$vs.notify({
              title: 'Success',
              text: 'File Uploaded Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 1000
            })
          } else {
            this.$emit('getImage', fileObject)

          }   
          this.$vs.loading.close()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    deleteUploadedFile (fileRecord) {

    },
    filesSelected (fileRecordsNewlySelected) {


      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)

      this.fileRecordsForUpload = fileRecordsNewlySelected
      if (!validFileRecords.length) {
        this.fileRecordsForUpload.length = 0
      }


    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {

        this.deleteUploadedFile(fileRecord)
      }
    }
  }
}
</script>
